export default __webpack_public_path__ + "scene2_2_bge2efb3.png";